
import { IRedeemResult, RedeemCouponI, RedeemCouponResponseI, FreeTrialI, UserCouponStatus, UserRedeemedCoupon, Coupon } from "@interfaces/coupon/coupon";
import fcCouponServiceApiInstance from "@services/clients/coupon";
import axiosApiInstance from "@services/custom-axios-instance";
import { generateUrl } from "@services/generateUrl/generateUrl";


export const redeemFreeTrial = (data: FreeTrialI) => {
    return axiosApiInstance
        .post(
            `${generateUrl()}/fc-coupon/redeem/coupon/trial/pr`,
            data
        ).then((response) =>  {
            const dataRes = response.data as RedeemCouponResponseI
            return dataRes.data as IRedeemResult
        })
}

export const redeemCouponPr = (data: RedeemCouponI) => {

    return axiosApiInstance.post(
        `${generateUrl()}/fc-coupon/redeem/coupon/pr`,
        data
    ).then((response) => {
        const dataRes = response.data as RedeemCouponResponseI;
        return dataRes.data as RedeemCouponResponseI;
    })
}

/**
 * @deprecated Not used in this project
 */
export async function verifyUserCoupons(data: UserCouponStatus): Promise<UserRedeemedCoupon[]>
{
    let endpoint = `/verify/user/${data.username}`
    const params = new URLSearchParams()
    if(data.status)
    {
        params.append("status", data.status)
    }

    if(params.entries.length > 0)
    {
        endpoint = endpoint + `?${params.toString()}`
    }
    const response = await fcCouponServiceApiInstance.get<RedeemCouponResponseI>(endpoint)
    const dataRes = response.data
    return dataRes.data as UserRedeemedCoupon[]
}

/**
 * Retrieve test DR Prox trial coupons used by the currently logged user.
 * The user data is retrieved from the token JWT
 * @returns Trial PR Premium coupons
 */
export async function checkTrialCoupon(): Promise<Coupon[]>
{
    const endpoint = "/verify/trial/expired"
    const response = await fcCouponServiceApiInstance.get<Coupon[]>(endpoint)
    const dataRes = response.data
    return dataRes
}

export async function userHasUsedCoupon(username: string): Promise<boolean>
{
    const endpoint = `/trial/used/${username}`
    const response = await fcCouponServiceApiInstance.get<boolean>(endpoint)
    return response.data
}

/**
 * upgrade coupon trial to subscription
 * The user data is retrieved from the token JWT
 * @returns Trial PR Premium coupons
 */
export async function updateTrial(practitionerUsername:string): Promise<string>
{
    const endpoint = `/trial/upgrade/${practitionerUsername}`
    const response = await fcCouponServiceApiInstance.put<string>(endpoint)
    const dataRes = response.data
    return dataRes
}

export async function cancelAllCouponsForUser(practitionerUsername: string)
{
    const endpoint = `/manage/coupon/upgrade/${practitionerUsername}`
    const response = await fcCouponServiceApiInstance.put<{status: number, data: boolean, error?: unknown}>(endpoint)
    return response.data
}
